// Broadcasts latency samples to any other tab/window listening (a metrics
// dashboard opened alongside the session). Optional: guarded so a browser
// without BroadcastChannel simply gets no metrics rather than an exception.
export const metricsChannel =
  typeof BroadcastChannel === 'function' ? new BroadcastChannel('openai-audio-metrics') : null;

export function publishMetricEvent(payload) {
  try {
    metricsChannel?.postMessage(payload);
  } catch (_error) {
    // A closed or unavailable channel must never break playback.
  }
}
